import styled from 'styled-components';

export const OnboardingPanelStyled = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  width: 100%;
`;

type OnboardingPanelStyledProps = {
  backgroundColor: string;
  borderColor?: string;
  opacity?: string;
};

export const OnboardingIconWrapper = styled.div<OnboardingPanelStyledProps>`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DescriptionTextStyled = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  padding: 0px 8px;
`;

const OnboardingPanelBaseStyled = styled.div<OnboardingPanelStyledProps>`
  flex: 1;
  display: flex;
  justify-content: space-between;
  padding: 8px;

  border: 1px solid ${({ borderColor }) => borderColor};
  background-color: ${({ backgroundColor, opacity = '1' }) =>
    `rgb(from ${backgroundColor} r g b / ${opacity})`};
`;

export const OnboardingDescriptionStyled = styled(OnboardingPanelBaseStyled)`
  border-radius: 0px 0px 8px 8px;
  align-items: center;

  font-size: 12px;
  font-weight: 500;

  &:hover {
    cursor: pointer;
  }
`;

export const OnboardingTitleStyled = styled(OnboardingPanelBaseStyled)`
  border-radius: 8px 8px 0px 0px;
  align-items: flex-end;
  border-bottom: none;
`;

export const onboardingPanelColors = {
  purple: {
    lowerBackgroundToken:
      'var(--ds-background-accent-purple-subtler, var(--ds-fb-background-accent-purple-subtler))',
    upperBackgroundToken:
      'var(--ds-background-accent-purple-subtlest, var(--ds-fb-background-accent-purple-subtlest))',
    icon: {
      primaryToken:
        'var(--ds-icon-accent-purple, var(--ds-fb-icon-accent-purple))',
      backgroundToken:
        'var(--ds-background-accent-purple-subtler, var(--ds-fb-background-accent-purple-subtler))',
    },
    text: 'var(--ds-text-accent-purple-bolder, var(--ds-fb-text-accent-purple-bolder))',
    border:
      'var(--ds-background-accent-purple-subtler, var(--ds-fb-background-accent-purple-subtler))',
    lozenge: 'new',
  },
  gray: {
    lowerBackgroundToken: 'var(--ds-surface, var(--ds-fb-surface))',
    upperBackgroundToken:
      'var(--ds-surface-sunken, var(--ds-fb-surface-sunken))',
    icon: {
      primaryToken: 'var(--ds-icon, var(--ds-fb-icon))',
      backgroundToken:
        'var(--ds-background-accent-gray-subtlest, var(--ds-fb-background-accent-gray-subtlest))',
    },
    text: 'var(--ds-text, var(--ds-fb-text))',
    border: 'var(--ds-border, var(--ds-fb-border))',
    lozenge: 'default',
  },
};
